import { Tooltip } from '../../../common/components/tooltip';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { observer } from 'mobx-react-lite';
import { useUnitStateColor } from '../../../configurable-colors-sounds/use-configured-colors';
import { getConfiguredUnitStatusColors } from '../../../configurable-colors-sounds/unit-status-colors';

export const StatusColorCell = observer(function StatusColorCell({
    value,
    tip,
    contentAlignment,
    data,
}: {
    value?: string;
    tip?: string;
    contentAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
    data: UnitQueueRowData;
}): React.ReactElement {
    const configuredColor = useUnitStateColor(data.unitStateId);
    const unitStatusColor =
        configuredColor.matched || data.unitStateGroup
            ? getConfiguredUnitStatusColors(configuredColor, data.unitStateGroup)
            : undefined;

    return (
        <Tooltip overlay={tip}>
            {/* The transparent border insets the fill without making the cell taller than the row */}
            <BaseQueueCell
                alignment={contentAlignment}
                backgroundColor={unitStatusColor ? unitStatusColor.fill : ''}
                color={unitStatusColor ? unitStatusColor.text : ''}
                border="md"
                borderColor="transparent"
                backgroundClip="padding-box"
                borderRadius="md"
            >
                {value}
            </BaseQueueCell>
        </Tooltip>
    );
});
